<template>
  <div class="d-flex c-gap-1 align-items-center">
    <img :src="url ?? '/img/default.png'" :alt="alt" />
    <span class="w-100">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: "NeoSelectImage",
  props: {
    url: {
      type: String | undefined,
      required: true,
    },
    alt: {
      type: String,
      required: true,
    },
    label: {
      type: String | undefined,
      required: true,
    },
  },
};
</script>

<style scoped>
img {
  width: 40px;
  height: 40px;
}
</style>
